import React, { useEffect,useState } from 'react';
import { addServiceException, removeServiceException, serviceExceptionList, userServiceList } from '../../../../store/actions/security/UserAccountMgmtAction';
import { Table, MinusSquareOutlined, CheckOutlined, Popconfirm, PlusSquareOutlined, Button, Tabs, useSelector, CloseOutlined, Row, Col, useDispatch,  Divider,message,Tooltip } from '../../../AntComponent';

export default function UserDetail(props) {

    const data = props.data.rowData;
    const items1 = [
        {
            key: "1",
            label: "App Services",
            children: <AppServices appuserID={data.appUserId} />
        },
        {
            key: "2",
            label: "App Service Exception",
            children: <AppServiceException appuserID={data.appUserId} />
        },

    ];


    const handleBack = () => {
        props.data.callbackFunction(false);
    };

    return (
        <div>
            <div className="d-flex p-3">
                <h6 className="my-auto">View User Detail</h6>
                <Button type="default" className="ms-auto mb-2" onClick={handleBack}>Back</Button>
            </div>

            <Divider className="mt-0" />
            <div className="bg-blue p-3">
                <div><span className="fw-bold">First Name:</span> <span>{data.firstName}</span></div>
                <div className='my-1'><span className="fw-bold">User Name:</span> <span>{data.appUserName}</span></div>
                <div className="d-flex w-75">
                    <div><span className="fw-bold">User Type:</span> <span>{data.userType}</span></div>
                    <div className='ms-5'><span className="fw-bold ms-auto">User Role:</span> <span>{data.roleName}</span></div>
                </div>
            </div>
            <div className="row mx-0 my-2 p-0 sub-tabs">
                <Tabs
                    className='px-0'
                    defaultActiveKey='1'
                    items={items1}
                />
            </div>
        </div>
    )
}

function AppServices(props) {
    const dispatch = useDispatch();
    const { appServiceData,success3 } = useSelector(state => state.userAccMgmt);
    const [showSuccessmsg,setShowsuccessmsg]=useState(false);
    const successmsg = showSuccessmsg?success3:null;
    const tableData = appServiceData?.data || [];

    useEffect(()=>{
     if(successmsg){
      message.success("Service Added Successfully");
      setShowsuccessmsg(false);
      getService();
     }
    },[successmsg]);

    function getException(){
        const ids = `${props.appuserID}`;
        dispatch(serviceExceptionList(ids));
    }

    function getService(){
        const ids = `${props.appuserID}`;
        dispatch(userServiceList(ids));
        getException();
    }
    useEffect(() => {
     getService();
    }, [props.appuserID]);

    function addService(id){
        let inputJson={
            "AppUserID": props.appuserID,
            "ServiceId": id
        }
        dispatch(addServiceException(inputJson));
        setShowsuccessmsg(true);
    }

    const columns = [
        {
            title: 'Service Name',
            dataIndex: 'serviceName',
            key: 'serviceName',
        },
        {
            title: 'Read',
            dataIndex: 'read_Attri',
            key: 'read_Attri',
            render: (read_Attri) => {
                return (
                    <div>{appServiceData ? read_Attri ? <CheckOutlined className='text-success'/> : !read_Attri?<CloseOutlined className='text-danger'/>:"---" : ""}</div>
                )
            }
        },
        {
            title: 'Write',
            dataIndex: 'write_Attri',
            key: 'write_Attri',
            render: (write_Attri) => {
                return (
                    <div>{appServiceData ? write_Attri ? <CheckOutlined className='text-success'/> :!write_Attri ?<CloseOutlined className='text-danger'/>:"---" : ""}</div>
                )
            }
        },
        {
            title: 'Delete',
            dataIndex: 'delete_Attri',
            key: 'delete_Attri',
            render: (delete_Attri) => {
                return (
                    <div>{appServiceData ? delete_Attri ? <CheckOutlined className='text-success'/> : !delete_Attri? <CloseOutlined className='text-danger'/>:"---" : ""}</div>
                )
            }
        },
        {
            title: 'Approve',
            dataIndex: 'approve_Attri',
            key: 'approve_Attri',
            render: (approve_Attri) => {
                return (
                    <div>{appServiceData ? approve_Attri ? <CheckOutlined className='text-success'/> : !approve_Attri?<CloseOutlined className='text-danger'/> :"---": ""}</div>
                )
            }
        },
        {
            title: 'Export',
            dataIndex: 'export_Attri',
            key: 'export',
            render: (export_Attri) => {
                return (
                    <div>{appServiceData ? export_Attri ? <CheckOutlined className='text-success'/> : !export_Attri?<CloseOutlined className='text-danger'/>:"---" : ""}</div>
                )
            }
        },

        {
            title: 'Add to Exception',
            dataIndex: 'action',
            key: 'action',
            render: (id, record) => {
                return (
                    <div className='p-3 text-center' onClick={(event) => { event.stopPropagation(); }}>
                       
                            <Popconfirm
                                placement="topLeft"
                                title="Are you sure to add this service?"
                                // description="Delete the patient"
                                onConfirm={() => addService(record.entServiceId)}
                                okText="Yes"
                                cancelText="No"
                            >
                                {/* <Tooltip title="Delete" className='mt-0'> */}
                               <span><Tooltip title="Add Service Exception" className='mt-0'><PlusSquareOutlined className='bg-success text-white' /></Tooltip></span>   
                                {/* </Tooltip> */}
                            </Popconfirm>
                        
                    </div>
                );
            }
        },
    ];

    return <div className='py-3 px-1'>
        <Table rowKey="entServiceId" columns={columns} dataSource={tableData} />
    </div>
}

function AppServiceException(props) {
    const dispatch = useDispatch();
    const { exceptionServiceData,success4 } = useSelector(state => state.userAccMgmt);
    const tableData = exceptionServiceData?.data || [];
    const [showSuccessmsg1,setShowsuccessmsg1]=useState(false);
    const successmsg1 = showSuccessmsg1?success4:null;

    function getService(){
        const ids = `${props.appuserID}`;
        dispatch(userServiceList(ids));
    }

    useEffect(()=>{
     if(successmsg1){
      message.success("Service Removed Successfully");
      getServiceException();
      getService();
      console.log("EEEEEEEEEEEEEEEEe");
      setShowsuccessmsg1(false);
    
     }
    },[successmsg1]);

    const columns = [
        {
            title: 'Service Name',
            dataIndex: 'serviceName',
            key: 'serviceName',
        },
        {
            title: 'Add to Exception',
            dataIndex: 'action',
            key: 'action',
            render: (id, record) => {
                return (
                    <div className='p-3 text-center' onClick={(event) => { event.stopPropagation(); }}>
                        <Tooltip title="Add Service Exception" className='mt-0'>
                            <Popconfirm
                                placement="topLeft"
                                title="Are you sure to remove the Service Exception?"
                                // description="Delete the patient"
                                onConfirm={() => removeExceptionService(record.entServiceExpID)}
                                okText="Yes"
                                cancelText="No"
                            >
                                {/* <Tooltip title="Delete" className='mt-0'> */}
                                <MinusSquareOutlined className='delete-icon bg-danger text-white' />
                                {/* </Tooltip> */}
                            </Popconfirm>
                        </Tooltip>
                    </div>
                );
            }
        },
    ];

    function getServiceException(){
        const ids = `${props.appuserID}`;
        dispatch(serviceExceptionList(ids));
    }

    useEffect(() => {
       getServiceException();
       console.log("DDDDDDDDDDDDDDDDDDDDDD");
    }, [props.appuserID]);

    function removeExceptionService(id){
        dispatch(removeServiceException(id));
        setShowsuccessmsg1(true);
    }

    return <div className='py-3 px-1'>
        <Table rowKey="entServiceExpID" columns={columns} dataSource={tableData} />
    </div>
}

